const errorText = (error) => {
  if (typeof error === "string") return error;
  if (!error || typeof error !== "object") return String(error);
  const message = error.message || error.error || error.reason || error.description;
  const row = error.rowNumber ?? error.row;
  if (message) {
    const text = typeof message === "string" ? message : JSON.stringify(message);
    return row != null ? `Row ${row}: ${text}` : text;
  }
  return JSON.stringify(error);
};

export const getProductImportResult = (response) => {
  const raw = response?.response?.data ?? response?.data ?? response;
  let payload = raw?.data ?? raw?.result ?? raw;
  if (typeof payload === "string") {
    try { payload = JSON.parse(payload); } catch { /* Keep plain-text responses. */ }
  }
  const report = { ...payload, ...payload?.summary };
  const rawErrors = report.errors ?? report.rowErrors ?? report.validationErrors;
  const errors = (Array.isArray(rawErrors)
    ? rawErrors
    : rawErrors ? [rawErrors] : []).map(errorText);
  const failed = Boolean(
    response?.isAxiosError || response?.response || response?.status >= 400 ||
    report.success === false || report.valid === false ||
    Number(report.failedRows) > 0 || errors.length > 0 ||
    ["FAILED", "ERROR", "VALIDATION_FAILED"].includes(String(report.status).toUpperCase()),
  );
  const message = payload?.message || payload?.error ||
    (typeof payload === "string" ? payload : null) || response?.message ||
    (failed ? "Could not import products. Please check the file and try again." : "Products imported successfully.");
  if (failed && !errors.length) errors.push(errorText(message));
  return {
    failed,
    message: errorText(message),
    summary: [
      ["Mode", report.mode ?? "Import"],
      ["Total Rows", report.totalRows ?? "—"],
      ["Products", report.products ?? "—"],
      ["Imported Products", report.importedProducts ?? "—"],
      ["Imported SKUs", report.importedSkus ?? report.importedSKUs ?? "—"],
      ["Failed Rows", report.failedRows ?? "—"],
    ].map(([label, value]) => [label, typeof value === "object" ? JSON.stringify(value) : value]),
    errors,
  };
};
